import { render, staticRenderFns } from "./CurriculumVitaeList.vue?vue&type=template&id=d59db3a0"
import script from "./CurriculumVitaeList.vue?vue&type=script&lang=js"
export * from "./CurriculumVitaeList.vue?vue&type=script&lang=js"
import style0 from "./CurriculumVitaeList.vue?vue&type=style&index=0&id=d59db3a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports